const $ = window.$;
 
export  function setSpeedMeter(id,value,color){
	let p = (value * 100)/120;
	let container = $("#"+id).parent();
	let c = '#0e82f9';
	if(color == "red")
		c = '#ff0000';
	$("#"+id).remove();
	container.append('<div id="'+id+'" style="left:8px"></div>');
	$("#"+id).circliful({
		animation: 0,
            animationStep: 100,
            foregroundBorderWidth: 5,
            backgroundBorderWidth: 1,
            percent: p,
			iconColor: c,
			foregroundColor:c,
            icon: 'f3fd',
            iconSize: '55',
			iconPosition: 'middle',
			text: value + " Km/hr.",
        	textStyle: 'font-size: 45px;',
			replacePercentageByText:"",
			fontColor: "#000",
			percentageTextSize:0,
			textY:145,
			halfCircle: 1,
	});
	// $("#"+id).circliful({
	// 	animation: 0,
    //         animationStep: 100,
    //         foregroundBorderWidth: 5,
    //         backgroundBorderWidth: 1,
    //         percent: p,
	// 		iconColor: c,
	// 		foregroundColor:c,
    //         icon: 'f3fd',
    //         iconSize: '55',
	// 		iconPosition: 'middle',
	// 		text:"ความเร็ว",
    //     	textStyle: 'font-size: 28px;',
	// 		//percentageTextSize:12,
	// 		replacePercentageByText: value + " Km/hr.",
	// 		fontColor: "#000",
	// 		textAdditionalCss: "font-weight: bold;background-color: #fff",
	// 		percentageTextSize:28,
	// 		textY:125,
	// 		halfCircle: 1,
	// });

}

export  function setGasMeter(id,value){
	let container = $("#"+id).parent();
	$("#"+id).remove();
	container.append('<div id="'+id+'" style="right:0px"></div>');
	$("#"+id).circliful({
		animation: 0,
            animationStep: 100,
            foregroundBorderWidth: 5,
            backgroundBorderWidth: 1,
            percent: value=="-"?0: value,
			iconColor: 'var(--color-icon)',
			foregroundColor:'var(--color-icon)',
            icon: 'f52f',
            iconSize: '55', 
			iconPosition: 'middle',
			text:value+"%",
			textStyle: 'font-size: 45px;',
			fontColor: "#000",
			textAdditionalCss: "font-weight: bold",
			replacePercentageByText: "",
			percentageTextSize:0,
			textY:145,
			halfCircle: 1,
	});
	// $("#"+id).circliful({
	// 	animation: 0,
    //         animationStep: 100,
    //         foregroundBorderWidth: 5,
    //         backgroundBorderWidth: 1,
    //         percent: value,
	// 		iconColor: 'var(--color-icon)',
	// 		foregroundColor:'var(--color-icon)',
    //         icon: 'f52f',
    //         iconSize: '55', 
	// 		iconPosition: 'middle',
	// 		text:"น้ำมัน",
	// 		textStyle: 'font-size: 28px;',
	// 		fontColor: "#000",
	// 		textAdditionalCss: "font-weight: bold",
	// 		percentageTextSize:28,
	// 		textY:125,
	// 		halfCircle: 1,
	// });

}


// WEBPACK FOOTER //
// ./src/app/view/components/Monitor/MeterCircle/js/MerterCircle.js